module.exports = __webpack_public_path__ + "img/cun_new_logo_copy.5932ff61.png";